import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=6483a38e&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivacy.vue?vue&type=style&index=0&id=6483a38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6483a38e",
  null
  
)

export default component.exports